import { render, staticRenderFns } from "./AutomationGeneralInsights.vue?vue&type=template&id=582b7173&scoped=true"
import script from "./AutomationGeneralInsights.vue?vue&type=script&lang=js"
export * from "./AutomationGeneralInsights.vue?vue&type=script&lang=js"
import style0 from "./AutomationGeneralInsights.vue?vue&type=style&index=0&id=582b7173&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b7173",
  null
  
)

export default component.exports